export default __webpack_public_path__ + "static/RecueilAvis1-7c48af2a83022513398f3e534241dc97.png";